export const environment = {
    weekServiceURL: process.env.REACT_APP_WEEK_URL,
    picksServiceURL: process.env.REACT_APP_PICKS_URL,
    userServiceURL: process.env.REACT_APP_USER_URL,
    leagueServiceURL: process.env.REACT_APP_LEAGUE_URL,
    messageServiceURL: process.env.REACT_APP_MESSAGE_URL
}